// extracted by mini-css-extract-plugin
module.exports = {"mSizingGuide":"kx","bold":"lx","tableContainer":"mx","selected":"nx","sizePicker":"ox","error":"px","disabled":"qx","top":"rx","typeOneSelect":"sx","arrow":"tx","bottom":"ux"};